import './Benefits.scss';

import type { ReactNode } from 'react';

import ArrowBullet from '@components/ArrowBullet/arrowBullet';
import HeadlineText from '@components/HeadlineText/HeadlineText';
import { useOrderContext } from '@pages/order/hooks/useOrderContext';

interface BenefitListItemProps {
  title: string;
  description: ReactNode;
}

const BenefitListItem = ({ title, description }: BenefitListItemProps) => {
  return (
    <li>
      <ArrowBullet />
      <div className='content'>
        <h4 className='heading'>{title}</h4>
        <p>{description}</p>
      </div>
    </li>
  );
};

export const Benefits = () => {
  const desktopBackgroundImageSrc = '/img/block-backgrounds/teal-white-dots-background.webp';
  const mobileBackgroundImageSrc = '/img/block-backgrounds/teal-white-dots-mobile.webp';

  const { partnerConfig } = useOrderContext();
  const benefits = partnerConfig?.benefits || [];

  return (
    <section className='benefits'>
      <HeadlineText theme='light' className='benefits'>
        <h2 className='headline-text__title'>What You&apos;ll Receive</h2>
        <div className='headline-text__description-wrapper'>
          <ul>
            {benefits.map(benefit => (
              <BenefitListItem key={benefit.title} title={benefit.title} description={benefit.description} />
            ))}
          </ul>
        </div>
      </HeadlineText>
      <div className='benefits__bg-image'>
        {desktopBackgroundImageSrc && (
          <img src={desktopBackgroundImageSrc} className='desktop' alt='Decorative background image' />
        )}

        {mobileBackgroundImageSrc && (
          <img src={mobileBackgroundImageSrc} className='mobile' alt='Decorative background image' />
        )}
      </div>
    </section>
  );
};
